// © Microsoft Corporation. All rights reserved.

import { Tag, UGContent } from "@msnews/social-data-service";

import React from "react";
import { UGContentConnector } from "../../Social.props";
import { SocialClassNameContract } from "../../Social.classnames";
import { SocialLocalizedStrings } from "../../Social.localizedStrings";
import TagInput from "../tag-input/TagInput";

interface UGContentCreateView2Props {
    managedClasses?: SocialClassNameContract;
    ugContent?: UGContent;
    ugContentConnector: UGContentConnector;
    t?: SocialLocalizedStrings;
}

interface UGContentCreateView2State {
    tagOptions: Array<Tag>,
    categoryOptions: Array<Tag>,
    locationOptions: Array<Tag>
}

export default class UGContentCreateView2 extends React.Component<UGContentCreateView2Props, UGContentCreateView2State> {

    constructor(props) {
        super(props);
    }

    async componentDidMount() {
        const tags = await this.props.ugContentConnector.fetchTags();
        const categories = await this.props.ugContentConnector.fetchCategories();
        const locations = await this.props.ugContentConnector.fetchLocations();
        this.setState({
            tagOptions: tags,
            categoryOptions: categories,
            locationOptions: locations
        });
    }

    tagsChangeHandler(items: Array<Tag>) {
        this.props.ugContentConnector.saveUGContent({tags: items});
    }

    categoriesChangeHandler(items: Array<Tag>) {
        this.props.ugContentConnector.saveUGContent({categories: items});
    }

    locationChangeHandler(items: Array<Tag>) {
        this.props.ugContentConnector.saveUGContent({locations: items});
    }

    render() {
        const { managedClasses, ugContent, t} = this.props;
        if (!this.state) { return null; }

        return (
            <div className={managedClasses.ugContentCreateView2Container}>
                <div className="cwt-content-generation-form">
                    <div className="cwt-text-input-group">

                        <label className="cwt-label">{t.UGContentCreatePageTags}</label>
                        <TagInput
                            className="cwt-input"
                            placeholder={t.UGContentCreatePageSelection}
                            managedClasses={managedClasses}
                            onChange={this.tagsChangeHandler.bind(this)}
                            options={this.state.tagOptions}
                            items={ugContent && ugContent.tags || []}
                        />

                        <label className="cwt-label">{t.UGContentCreatePageCategories}</label>
                        <TagInput
                            className="cwt-input"
                            placeholder={t.UGContentCreatePageSelection}
                            managedClasses={managedClasses}
                            onChange={this.categoriesChangeHandler.bind(this)}
                            options={this.state.categoryOptions}
                            items={ugContent && ugContent.categories || []}
                        />

                        <label className="cwt-label">{t.UGContentCreatePageLocation}</label>
                        <TagInput
                            className="cwt-input"
                            placeholder={t.UGContentCreatePageSelection}
                            managedClasses={managedClasses}
                            onChange={this.locationChangeHandler.bind(this)}
                            options={this.state.locationOptions}
                            items={ugContent && ugContent.locations || []}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
